export enum DescriptionPlacement {
  ABOVE_PRICE_AND_PURCHASE_OPTIONS = 'Above Price And Purchase Options',
  BELOW_PRICE_AND_PURCHASE_OPTIONS = 'Below Price and Purchase Options',
}

export function getDescriptionPlacement(
  value: string | undefined
): DescriptionPlacement {
  if (value === DescriptionPlacement.BELOW_PRICE_AND_PURCHASE_OPTIONS) {
    return DescriptionPlacement.BELOW_PRICE_AND_PURCHASE_OPTIONS;
  }
  return DescriptionPlacement.ABOVE_PRICE_AND_PURCHASE_OPTIONS;
}
